import { getToken } from "@/utils/authHelpers";
import axios from "axios";
import { API_BASE_URL } from "@/utils/api";

export const createProjectApi = async (
  name: string,
  description?: string,
  deadline?: Date | null,
): Promise<void> => {
  const token = await getToken();
  if (!token) throw new Error("No authentication token found");

  const deadlineDate = deadline ? deadline.toISOString().split("T")[0] : null;

  await axios.post(
    `${API_BASE_URL}/projects`,
    {
      name,
      description,
      deadline: deadlineDate,
    },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};
